import { fetchWithTimeout } from "./api.fetcher"

export const updateAjusteMetrica = async(token,id,val) => {
    const formData = new FormData()
    formData.append('origin', 'frontend')
    formData.append('id', id)
    formData.append('val', val ? 1 : 0)
    return fetchWithTimeout(`ajustes_metricas_users/update`, {
        method: 'post',
        body: formData,
        headers : { Authorization : `Bearer ${token}` }
    })
}